import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDI } from '@/di/DIContext'
import { checkPasswordRequirements } from '@/domain/auth/validation/validatePassword'

export function useChangePassword() {
  const navigate = useNavigate()
  const { accountService, sessionService } = useDI()
  const agentId = sessionService.getAgentId()

  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const requirements = checkPasswordRequirements(newPassword)
  const validationRequirements = {
    ...requirements,
    match: newPassword === confirmPassword && newPassword.length > 0,
  }

  const handleSave = async () => {
    setIsLoading(true)
    setErrorMessage('')
    setSuccessMessage('')

    try {
      await accountService.updatePassword(agentId!, {
        oldPassword: currentPassword,
        newPassword,
        confirmPassword,
      })
      setSuccessMessage('Password updated successfully')
      navigate('/me')
    } catch (error) {
      const err = error as Error
      setErrorMessage(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const canSave =
    Object.values(validationRequirements).every(Boolean) &&
    currentPassword.length > 0

  return {
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    isLoading,
    errorMessage,
    successMessage,
    handleSave,
    canSave,
    validationRequirements,
  }
}
